"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Cookies: true,
  CookiesProvider: true,
  withCookies: true,
  useCookies: true
};
Object.defineProperty(exports, "Cookies", {
  enumerable: true,
  get: function get() {
    return _Cookies["default"];
  }
});
Object.defineProperty(exports, "CookiesProvider", {
  enumerable: true,
  get: function get() {
    return _CookiesProvider["default"];
  }
});
Object.defineProperty(exports, "withCookies", {
  enumerable: true,
  get: function get() {
    return _withCookies["default"];
  }
});
Object.defineProperty(exports, "useCookies", {
  enumerable: true,
  get: function get() {
    return _useCookies["default"];
  }
});

var _Cookies = _interopRequireDefault(require("./Cookies"));

var _CookiesProvider = _interopRequireDefault(require("./CookiesProvider"));

var _withCookies = _interopRequireDefault(require("./withCookies"));

var _useCookies = _interopRequireDefault(require("./useCookies"));

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/react-cookie@4.1.1_react@16.14.0/~/react-cookie/cjs/index.js
// module id = 500
// module chunks = 0